<template>
  <div>
    <MMContactNavbar v-if="isPage1 || isPagePdf" />
    <MMMSEData v-if="isPage1 || isPagePdf" />
    <MMNavbar v-if="isPage1 || isPagePdf" />
    <MW2023Navbar v-if="isPage2" />
    <MWNavbar v-if="isPage3" />
    <YPNavbar v-if="isPage4" />
    <RouterView />
    <MMFooter v-if="isPage1" />
    <MW2023Footer v-if="isPage2" />
    <MWSponserSlide v-if="isPage3" />
    <MWFooter v-if="isPage3" />
    <YPFooter v-if="isPage4" />
    <QuickContact
      v-if="isPage1 || isPage2"
      :backgroundColor="isPage1 ? 'bg-green' : 'bg-[#00a375]'"
    />
    <BackToTheTopButton :backgroundColor="backToTopColor" />
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
// mining mongolia
import MMMSEData from "./components/MiningMongolia/MMMSEData.vue";
import MMContactNavbar from "./components/MiningMongolia/MMContactNavbar.vue";
import MMNavbar from "./components/MiningMongolia/MMNavbar.vue";
import MMFooter from "./components/MiningMongolia/MMFooter.vue";
import QuickContact from "./components/ui/QuickContact.vue";
import BackToTheTopButton from "./components/ui/BackToTheTopButton.vue";
// mining week
import MW2023Navbar from "./components/MiningWeek/MW2023/MW2023Navbar.vue";
import MW2023Footer from "./components/MiningWeek/MW2023/MW2023Footer.vue";
import MWNavbar from "./components/MiningWeek/MW2024/MWNavbar";
import MWSponserSlide from "./components/MiningWeek/MW2024/MWSponserSlide.vue";
import MWFooter from "./components/MiningWeek/MW2024/MWFooter";
// new yellow page
import YPNavbar from "./components/YellowPage/YPNavbar.vue";
import YPFooter from "./components/YellowPage/YPFooter.vue";

export default {
  name: "App",
  components: {
    MMMSEData,
    MMContactNavbar,
    MMNavbar,
    MMFooter,
    QuickContact,
    BackToTheTopButton,
    MW2023Navbar,
    MW2023Footer,
    MWNavbar,
    MWSponserSlide,
    MWFooter,
    YPNavbar,
    YPFooter,
  },
  setup() {
    const route = useRoute();

    const isPage1 = computed(() => route.path.includes("/mm"));
    const isPage2 = computed(() => route.path.includes("/mw/2023"));
    const isPage3 = computed(
      () => route.path.includes("/mw") && !route.path.includes("/mw/2023")
    );
    const isPage4 = computed(() => route.path.includes("/yp"));
    const isPagePdf = computed(() => route.path.includes("/mn"));

    onMounted(() => {
      const domain = window.location.hostname;
      const body = document.body;

      if (domain.includes("miningmongolia.mn")) {
        body.classList.add("miningmongolia-scrollbar");
      } else if (domain.includes("miningweek.mn")) {
        body.classList.add("miningweek-scrollbar");
      } else if (domain.includes("miningguide")) {
        body.classList.add("miningguide-scrollbar");
      } else if (domain.includes("localhost")) {
        body.classList.add("miningguide-scrollbar");
      }
    });

    const backToTopColor = computed(() => {
      if (isPage1.value) return "bg-green";
      if (isPage2.value || isPage3.value) return "bg-[#00a375]";
      if (isPage4.value) return "bg-[#ffd100]";
      return "bg-green";
    });

    return {
      isPage1,
      isPage2,
      isPage3,
      isPage4,
      backToTopColor,
      isPagePdf,
    };
  },
};
</script>

<style>
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgb(226 232 240);
}

.miningmongolia-scrollbar::-webkit-scrollbar-thumb {
  background: #537d23 !important;
}

.miningweek-scrollbar::-webkit-scrollbar-thumb {
  background: #003d31 !important;
}

.miningguide-scrollbar::-webkit-scrollbar-thumb {
  background: #ffd100 !important;
}
</style>
